import React, { useEffect } from 'react';
import AppRoutes from './Routes/AppRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import '../src/css/bootstrap.min.css';
import '../src/css/owl.theme.default.min.css';
import '../src/css/owl.carousel.min.css';
import '../src/css/magnific-popup.min.css';
import '../src/css/animate.css';
import '../src/css/boxicons.min.css';
import '../src/css/font-awesome.min.css';
import '../src/css/remixicon.css';
import '../src/css/nice-select.css';
import '../src/css/odometer.css';
import '../src/css/aos.css';
import '../src/css/style.css';
import '../src/css/responsive.css';
import AOS from 'aos'; // ✅ Import AOS
import GoTop from './Components/GoTop';

const App = () => {
  useEffect(() => {
    AOS.init({ once: true });
    AOS.refresh();
  }, []);

  return (
    <>
      <AppRoutes />
      <GoTop />
      <ToastContainer />
    </>
  );
};

export default App;